import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import AnalyticsLayout from '@/views/v2/layouts/survey/Analytics.vue';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import Graph from '@/components/v2/Graph';
let Performance = class Performance extends Vue {
    constructor() {
        super(...arguments);
        this.viewsLabel = 'Views';
        this.averageViewsLabel = 'Average Views';
        this.activeUsersLabel = 'Active Users';
        this.buttonClicks = '"Count Me In" button clicks';
        this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.ageRange = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
    }
};
Performance = __decorate([
    Component({
        components: {
            BaseAnalyticsBanner,
            AnalyticsLayout,
            BaseAnalyticsBannerContent,
            Graph,
        },
    })
], Performance);
export default Performance;
